import { render, staticRenderFns } from "./medicion-frecuencia-grafica.vue?vue&type=template&id=090ab27e&scoped=true&"
import script from "./medicion-frecuencia-grafica.vue?vue&type=script&lang=js&"
export * from "./medicion-frecuencia-grafica.vue?vue&type=script&lang=js&"
import style0 from "./medicion-frecuencia-grafica.vue?vue&type=style&index=0&id=090ab27e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090ab27e",
  null
  
)

export default component.exports